//Header
$(function() {
    var header = $("#header");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 10) {
            header.removeClass('start-style').addClass("scroll-on");
        } else {
            header.removeClass("scroll-on").addClass('start-style');
        }
    });
});

$('body').on('mouseenter mouseleave','.nav-item',function(e){
    if ($(window).width() > 750) {
        var _d=$(e.target).closest('.nav-item');_d.addClass('show');
        setTimeout(function(){
            _d[_d.is(':hover')?'addClass':'removeClass']('show');
        },1);
    }
});

$(function() { //run when the DOM is ready
    $("#menu-burger").click(function() { //use a class, since your ID gets mangled
        $('body').toggleClass("nav-open"); //add the class to the clicked element
    });
});

///
$("#header .main-menu li.menu-item-has-children > a").on("click", function(b) {
    $(window).width() < 1161 && (b.preventDefault(), $(this).parent().hasClass("open") ? ($(this).parent().removeClass("open"), $(this).next(".sub-menu").slideUp("fast")) : ($("#header .main-menu li.open .sub-menu").slideUp("fast"), $("#header .main-menu li").removeClass("open"), $(this).next(".sub-menu").slideDown("fast"), $(this).parent().addClass("open")))
})
